export * from '@primeuix/themes/nora/overlaybadge';
export { default } from '@primeuix/themes/nora/overlaybadge';
